// Recently-Viewed helpers — localStorage (max 12, dedup by id, newest first)
const KEY = "carhive_recent_views_v1";
const MAX = 12;

function readRaw() {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeRaw(list) {
  try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); }
  catch { /* quota — ignore */ }
}

export function recordView(listing) {
  if (!listing || !listing.id) return;
  const entry = {
    id: listing.id,
    brand: listing.brand || "",
    model: listing.model || "",
    title: listing.title || "",
    price_chf: listing.price_chf ?? null,
    year: listing.year ?? null,
    mileage_km: listing.mileage_km ?? null,
    images: Array.isArray(listing.images) ? listing.images.slice(0, 1) : [],
    fuel: listing.fuel || null,
    transmission: listing.transmission || null,
    location: listing.location || null,
    seller_dealer: listing.seller_dealer || null,
    featured: !!listing.featured,
    featured_until: listing.featured_until || null,
    condition: listing.condition || null,
    warranty_months: listing.warranty_months || 0,
    viewed_at: new Date().toISOString(),
  };
  const list = readRaw().filter((e) => e.id !== listing.id);
  list.unshift(entry);
  writeRaw(list);
}

export function getRecentViews({ excludeId } = {}) {
  return readRaw().filter((e) => !excludeId || e.id !== excludeId);
}

export function removeRecentView(id) {
  writeRaw(readRaw().filter((e) => e.id !== id));
}

/** Phase 72 — Batch-drop stale entries whose listing is no longer active on
 *  the server. Returns the pruned list. Silent on network failure (fail-open).
 */
export function pruneRecentViews(activeIds) {
  const set = new Set(Array.isArray(activeIds) ? activeIds : []);
  const kept = readRaw().filter((e) => set.has(e.id));
  writeRaw(kept);
  return kept;
}

export function clearRecentViews() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

export { MAX as RECENT_VIEWS_MAX };
